document.addEventListener('DOMContentLoaded', function() {
  //console.log('Cart attributes script loaded');
  
  // Manually save these cart attributes as this doesn't seem to work automatically anymore
  const atlCheck = document.getElementById('atl-check');
  if (atlCheck) {
    //console.log('atl-check element found');
    atlCheck.addEventListener('change', function () {
      //console.log('atl-check changed, checked:', this.checked, 'value:', this.value);
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'authority-to-leave': this.checked ? this.value : '0'
          }
        })
      }).then(function (response) {
        //console.log('atl-check response status:', response.status);
        return response.json();
      }).then(function (data) {
        //console.log('atl-check response data:', data);
      }).catch(function (error) {
        //console.error('atl-check error:', error);
      });
    });
  } else {
    //console.warn('atl-check element not found');
  }

  const hsBrochuresCheck = document.getElementById('hs-brochures-check');
  if (hsBrochuresCheck) {
    //console.log('hs-brochures-check element found');
    hsBrochuresCheck.addEventListener('change', function () {
      //console.log('hs-brochures-check changed, checked:', this.checked, 'value:', this.value);
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'hs-brochures': this.checked ? this.value : '0'
          }
        })
      }).then(function (response) {
        //console.log('hs-brochures-check response status:', response.status);
        return response.json();
      }).then(function (data) {
        //console.log('hs-brochures-check response data:', data);
      }).catch(function (error) {
        //console.error('hs-brochures-check error:', error);
      });
    });
  } else {
    //console.warn('hs-brochures-check element not found');
  }

  // The hsPoNumber handler was removed 2026-09-19 along with the custom PO Number field in
  // snippets/hs-checkout-fields.liquid. Native Shopify B2B provides its own PO number field
  // at checkout, so this was duplicate capture writing attributes[po-number].

  // Previous-formulae disclosure in snippets/hs-product-ingredients.liquid.
  // Ported from live Flex assets/hsAccordion.js:79-94, with one deliberate change: Flex looks
  // the panel up by document.getElementById('previous-formulae'), which is wrong here because
  // core Prestige's sections/tabs.liquid renders each block's content twice (desktop <x-tabs>
  // + mobile .accordion-group), so that id existed twice and every toggle resolved to the
  // first — the desktop copy, hidden below the sm breakpoint. The panel now carries no id and
  // is found relative to its own toggle, so each copy drives the one next to it.
  document.querySelectorAll('.previous-formulae__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      var scope = toggle.closest('[data-hs-ingredients-content]') || document;
      var panel = scope.querySelector('.previous-formulae__list');
      if (!panel) return;

      var isHidden = panel.hasAttribute('hidden');
      if (isHidden) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(isHidden));
      toggle.textContent = isHidden ? 'Hide previous formulae' : 'View previous formulae';
    });
  });
});

/*
  Discount code: APPLY button, and Enter no longer goes to checkout (Phoebe, 2026-09-26).
  Markup: the HS block in snippets/cart-discount.liquid (cart page and cart drawer).

  Stock Prestige applies a code on the field's `change` event (CartDiscountField ->
  toggleDiscount in theme.js, which reads event.target.value), i.e. when the customer tabs out.
  Enter instead submitted the surrounding cart form, whose default button is CHECKOUT, so the
  customer skipped the cart and Kite never got the chance to remove a free gift that the
  discount had taken the cart below the $50 threshold for. Now APPLY and Enter both fire that
  same `change` event, so the theme's own apply-and-refresh logic runs unchanged.

  Listeners are delegated on document because the drawer's markup is re-rendered on every cart
  change. hsSent remembers the value last sent, so tabbing out and then clicking APPLY (the
  click blurs the field first, which already fires `change`) applies the code once, not twice.
  A rejected code clears it, so the customer can correct the code and retry.
*/
(function () {
  var FIELD_INPUT = 'cart-discount-field input:not([type="hidden"])';

  function applyDiscount(input) {
    if (!input || !input.value.trim() || input.dataset.hsSent === input.value) return;
    input.dataset.hsSent = input.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // A real (browser-fired) change for a value already sent is a duplicate: stop it before
  // Prestige's handler on <cart-discount-field> sees it.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!e.isTrusted || !input.matches || !input.matches(FIELD_INPUT) || !input.value.trim()) return;
    if (input.dataset.hsSent === input.value) {
      e.stopImmediatePropagation();
      return;
    }
    input.dataset.hsSent = input.value;
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches(FIELD_INPUT)) return;
    e.preventDefault(); // no implicit form submission, so no jump to checkout
    applyDiscount(e.target);
  }, true);

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.hs-discount-apply');
    if (!button) return;
    var row = button.closest('.hs-discount-row');
    applyDiscount(row && row.querySelector(FIELD_INPUT));
  });

  document.addEventListener('cart:discount:error', function (e) {
    var input = e.target.querySelector && e.target.querySelector(FIELD_INPUT);
    if (input) delete input.dataset.hsSent;
  });
})();

// Cart rewards bar (snippets/hs-cart-rewards.liquid): free-gift and free-shipping progress in the
// cart drawer and on the cart page. Recomputes on every `cart:change`, the event Prestige's own
// <free-shipping-bar> listens to. Two totals (2026-09-27): free shipping counts the lines that need
// shipping plus any Mystery Product (swapped for a shippable product at fulfilment; no other
// no-shipping product counts), minus cart-level discounts; the free gift counts the whole cart
// after discounts (cart.total_price), as Kite does, so a Mystery Product (no shipping) still counts
// towards the gift. Gift cards count towards neither (Phoebe, 2026-09-27). Thresholds and messages
// come from the element's attributes (cents).
if (!window.customElements.get('hs-cart-rewards')) {
  window.customElements.define('hs-cart-rewards', class extends HTMLElement {
    connectedCallback() {
      this._onCartChange = (event) => {
        const cart = event.detail && event.detail.cart;
        if (!cart) return;
        const items = cart.items.filter((item) => item.requires_shipping || item.product_type === 'Mystery')
          .reduce((sum, item) => sum + item.final_line_price, 0);
        const cartDiscount = cart.cart_level_discount_applications
          .reduce((sum, application) => sum + application.total_allocated_amount, 0);
        this.setAttribute('total-price', items - cartDiscount);
        const giftCards = cart.items.filter((item) => item.gift_card)
          .reduce((sum, item) => sum + item.final_line_price, 0);
        this.setAttribute('gift-total-price', cart.total_price - giftCards);
        // Kite's gift is its own product, type "… (Free Gift)" (see hs-cart-rewards.liquid).
        this.toggleAttribute('gift-claimed', cart.items.some((item) => (item.product_type || '').includes('(Free Gift)')));
        this.update();
      };
      document.addEventListener('cart:change', this._onCartChange);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChange);
    }

    update() {
      const total = parseFloat(this.getAttribute('total-price')) || 0;
      const giftTotal = parseFloat(this.getAttribute('gift-total-price')) || total;
      const shipping = parseFloat(this.getAttribute('shipping-threshold')) || 0;
      const gift = parseFloat(this.getAttribute('gift-threshold')) || 0;
      const max = Math.max(shipping, gift);
      if (!max) return;

      const money = (cents) => new Intl.NumberFormat(Shopify.locale, {
        style: 'currency', currency: Shopify.currency.active, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
      const say = (key, cents) => (this.getAttribute(key) || '').replace('[amount]', money(cents));

      // The next milestone not yet reached decides the message.
      let message;
      const giftDone = !gift || giftTotal >= gift;
      const shippingDone = total >= shipping;
      if (giftDone && shippingDone) {
        message = this.getAttribute('msg-all');
      } else if (!giftDone && (shippingDone || gift <= shipping)) {
        message = say(shippingDone ? 'msg-shipping-gift-next' : 'msg-gift', gift - giftTotal);
      } else if (gift && giftDone) {
        message = say('msg-gift-shipping-next', shipping - total);
      } else {
        message = say('msg-shipping', shipping - total);
      }

      // Gift state for the drawer's "Claim it in your cart" link (CSS shows it on "unlocked"). While
      // that link is showing it carries the gift news, so in the drawer the message is about shipping
      // only (2026-09-30, audit 00). The cart page keeps the full message and bar.
      const claimed = this.hasAttribute('gift-claimed');
      this.dataset.giftState = !gift ? 'none' : claimed ? 'claimed' : giftDone ? 'unlocked' : 'locked';
      if (this.dataset.giftState === 'unlocked' && this.closest('.cart-drawer')) {
        message = shippingDone ? this.getAttribute('msg-shipping-done') : say('msg-shipping', shipping - total);
      }

      this.querySelector('.hs-cart-rewards__message').textContent = message;
      // The fill follows the total of the milestone the message is about, and never falls short of a
      // milestone already reached.
      const nextIsGift = !giftDone && (shippingDone || gift <= shipping);
      let fill = (nextIsGift ? giftTotal : total) / max;
      if (gift && giftDone) fill = Math.max(fill, gift / max);
      this.querySelector('.hs-cart-rewards__fill').style.width = Math.min(100, fill * 100) + '%';
      this.querySelectorAll('.hs-cart-rewards__marker').forEach((marker) => {
        const markerTotal = marker.dataset.total === 'gift' ? giftTotal : total;
        marker.classList.toggle('is-reached', markerTotal >= parseFloat(marker.dataset.threshold));
      });
    }
  });
}

// Availability message on variant change (snippets/hs-product-availability-message.liquid). On a
// variant change Prestige re-renders the section, but its <product-rerender> only swaps its own
// block types (theme.js onRerender_fn), so the server-rendered "out of stock" box stayed on screen
// after switching from a sold-out variant to an in-stock one (Factory 2nds, 2026-10-17). This swaps
// the HS availability blocks from the same re-rendered HTML. Capture phase, because Prestige
// dispatches `product:rerender` on the form without bubbling; clones, so the fragment stays intact
// for Prestige's own handler. A product change (or a scope without allow-partial-rerender) replaces
// the whole scope anyway, so those are left alone.
document.addEventListener('product:rerender', function (event) {
  const fragment = event.detail && event.detail.htmlFragment;
  if (!fragment || event.detail.productChange) return;
  // The form has an input named "id", so form.id is that input, not the attribute.
  const formId = event.target.getAttribute('id');
  document.querySelectorAll(`product-rerender[allow-partial-rerender][observe-form="${formId}"]`).forEach((scope) => {
    const fresh = fragment.querySelector(`#${CSS.escape(scope.id)}`);
    if (!fresh) return;
    const freshBlocks = fresh.querySelectorAll('.hs-product-block--availability');
    scope.querySelectorAll('.hs-product-block--availability').forEach((block, index) => {
      if (freshBlocks[index]) block.replaceWith(freshBlocks[index].cloneNode(true));
    });
  });
}, true);
